export default __webpack_public_path__ + "static/media/zine-cover6.403615f2.png";